function Enrollee(aEnrollee) {
    "use strict";

    this.__type = 'Enrollee:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.FirstName = '';
    this.FullName = '';
    this.LastName = '';

    this.AgentId = -1;
    this.Birthdate = new Date(-62135596800000);
    this.IsActive = false;
    this.IsAssigned = false;
    this.AudibleToneFlag = 0;
    this.OrganizationId = -1;
    this.PrimaryId = '';
    this.RiskLevelId = -1;
    this.SecondaryId = '';
    this.ArchiveFlag = 'N';
    this.TimeZoneCode = '';
    this.TimeZoneId = -1;
    this.ReferralDate = new Date(-62135596800000);
    this.EnrolleeType = 1;
    this.HasVictimFlag = false;
    this.HasAssociationFlag = 0;
    this.SoberTrackDeviceFlag = 0;
    this.OffenderPayFlag = 0;
    this.IsEnrollink = 0;
    this.TransactionId = '';
    if(aEnrollee && typeof aEnrollee !== "undefined" && aEnrollee !=null){
        for(var i in aEnrollee){
            this[i] = aEnrollee[i];
        }
    }
}
Enrollee.prototype = new DataObjectBaseClass();
Enrollee.prototype.constructor = Enrollee;
Enrollee.prototype.Save = function(aOnSuccess,aParam){
    var lBuilder = new SumoPredicateBuilder();
    var _this = this;
    var _OnSuccessFn = function (parameters,res){
        if(!isNullOrUndefined(res)){
            FixDates(res);
            var  obj= Object.assign({},_this,res,{__type:_this.__type});
            _this.setValues(obj);
            aOnSuccess(parameters,_this);

        }
    };
    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('TimeZoneCode', this.TimeZoneCode, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    var lTimezone = query(getDataItems('TimeZone'), lBuilder.RootExpression);
    for(var lKey in lTimezone) {
        if (lTimezone.hasOwnProperty(lKey)) {
            this.TimeZoneId = lTimezone[lKey].Id;
        }
    }
    this.FirstName = this.FirstName;
    this.LastName = this.LastName;
    this.Birthdate = '';
    this.FullName = this.LastName + ', ' + this.FirstName;
    WriteSingle(this, _OnSuccessFn, Sad, aParam, true);
   
};

Enrollee.prototype.GetDeviceAssignment = function(){
    var devices = [];
    if(!isNullOrUndefined(gCurrentDeviceAssignment[this.Id])){
        gCurrentDeviceAssignment[this.Id].map(function(a){devices.push(a);});
    }
    return devices;
}
Enrollee.prototype.GetVictim = function(aOnSuccess){
    var _this = this;
    if(this.Id){
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('SamaAssociateEnrolleeId', this.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.VictimProfile.AssemblyQualifiedName, lBuilder.RootExpression, 0, function(aParams,aData){
            _this.setValues(Object.assign({},_this,aData,{__type:_this.__type}));
            aOnSuccess(aParams,aData);
        }, failure, null, null, 0);
    }
};
if (typeof exports !== 'undefined') {
    module.exports = Enrollee;
}